import { render, staticRenderFns } from "./displayDetailWin.vue?vue&type=template&id=4bbc91f8&scoped=true&"
import script from "./displayDetailWin.vue?vue&type=script&lang=js&"
export * from "./displayDetailWin.vue?vue&type=script&lang=js&"
import style0 from "./displayDetailWin.vue?vue&type=style&index=0&id=4bbc91f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbc91f8",
  null
  
)

export default component.exports